import classNames from 'classnames'
import React from 'react'

import MorePropTypes from '../../../utils/MorePropTypes'
import s from './Tooltip.module.scss'
import TooltipContent from './TooltipContent'

export default function DesktopTooltip({ children, text, title }) {
  return (
    <div className={classNames(s.container, s.desktop)}>
      <div className={s.anchor}>{children}</div>
      <div className={classNames(s.tooltip, s.desktop)}>
        <TooltipContent text={text} title={title} />
      </div>
      <div className={classNames(s.arrow, s.desktop)} />
    </div>
  )
}

DesktopTooltip.propTypes = MorePropTypes.tooltipProps.isRequired
